<template>
  <div id="popIdentifier" refs="popIdentifier">
    <div v-if="showPopIdElement" id="popIdentifierRow">
      <div id="popIdentifierOptionWrapper">
        <div id="popIdentifierOption" :class="[{'edit-text': editText }]">
          <div class="base">
            <div class="text-display text">{{currentTextDisplay}}</div>
            <div class="text-input">
              <el-autocomplete
                id="popid-input"
                :model-value="popIdInputValue"
                @update:model-value="newValue => popIdInputValue = newValue"
                class="input-new-tag custom-tags-auto-complete"
                ref="addPopIdInputEl"
                :popper-class="'popId-input custom-popIds-auto-complete-dropdown'"
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                @input="handleInputTag($event)"
                @select="handleConfirmInputValue($event, 'suggestionSelect')">
            </el-autocomplete>
            </div>
            <div
              class="base-cover"
              @click="handleBaseCoverClick($event)"
              @mouseover="handlePopIdHover($event, 'mouseover')"
              @mouseout="handlePopIdHover($event, 'mouseout')">
              <div @click="handleDeletePopIdClick($event)" class="delete-icon"></div>
            </div>
          </div>
          <div class="pop-icon"></div>
        </div>
      </div>
    </div>

    <el-button v-if="showAddButton" @click="handleAddButtonClick" :class="['add-button', {'has-value': currentTextValue}]"></el-button>
  </div>
</template>

<script src="./pop-identifier.js"></script>
<style lang="scss" src="./pop-identifier.scss"></style>
